module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'editMotionFileForAdmin',
        params: {
          motionFileId: _vm.data.motionId
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('edit')
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-edit"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "data-toggle": "modal",
      "data-target": _vm.targetDangerModalId,
      "data-placement": "top",
      "title": _vm.$t('trash')
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_new"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-danger fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.dangerModalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].deleteMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_motion_action_remove(_vm.data.motionId)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].submit) + "\n                    ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Danger")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d37d40aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ListMotionFileActionForAdmin.vue
// module id = 1507
// module chunks = 1